//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    name: 'AppsDropdown',

    data(){ return {
        version: 1,
        loaded: false,
        apps: [

        ],

        experimental: [
            { name: 'Homepage', short: 'Web',
              icon: 'fas fa-home', color: 'grey-8',
              url: '/web'
            },
            { name: 'Authentication', short: 'Auth',
              icon: 'fa fa-fingerprint', color: 'blue-5',
              url: '/auth'
            },
            { name: 'YouTube Manager', short: 'YTM',
              icon: 'fab fa-youtube', color: 'red-7',
              url: '/ytm'
            },
            { name: 'Quality Management', short: 'QM', icon: 'fa fa-list-alt', image_: ('~/assets/ytm/1_white.svg'), color: 'brown-5' },
        ]
    }},

    mounted(){
    },

    computed: {
        user(){ return this.$store.getters['auth/user'] },
    },

    methods: {
        loadInnerContent(){
            if(!this.loaded)
            this.loadApps()
        },

        loadApps(){
            axios.get('/api/core/apps')
                 .then( r => {

                    if(r.data.apps)
                    this.apps = r.data.apps

                    setTimeout( () => {
                        this.loaded = true
                    }, 1)
                 })
                 .catch(e => console.log(e.response))
        }
    }
}
